var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgChevronRightMedium20(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.793 6.293a1 1 0 011.414 0l3 3a1 1 0 010 1.414l-3 3a1 1 0 01-1.414-1.414L10.086 10 7.793 7.707a1 1 0 010-1.414z",
    fill: "currentColor"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik03Ljc5Mjg5IDYuMjkyODlDOC4xODM0MiA1LjkwMjM3IDguODE2NTggNS45MDIzNyA5LjIwNzExIDYuMjkyODlMMTIuMjA3MSA5LjI5Mjg5QzEyLjU5NzYgOS42ODM0MiAxMi41OTc2IDEwLjMxNjYgMTIuMjA3MSAxMC43MDcxTDkuMjA3MTEgMTMuNzA3MUM4LjgxNjU4IDE0LjA5NzYgOC4xODM0MiAxNC4wOTc2IDcuNzkyODkgMTMuNzA3MUM3LjQwMjM3IDEzLjMxNjYgNy40MDIzNyAxMi42ODM0IDcuNzkyODkgMTIuMjkyOUwxMC4wODU4IDEwTDcuNzkyODkgNy43MDcxMUM3LjQwMjM3IDcuMzE2NTggNy40MDIzNyA2LjY4MzQyIDcuNzkyODkgNi4yOTI4OVoiIGZpbGw9ImN1cnJlbnRDb2xvciIvPgo8L3N2Zz4K";
export { SvgChevronRightMedium20 as ReactComponent };